import { render, staticRenderFns } from "./CmgAddRewardModal.vue?vue&type=template&id=f9e34526&scoped=true&lang=pug&"
import script from "./cmg-add-reward-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-add-reward-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAddRewardModal.vue?vue&type=style&index=0&id=f9e34526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e34526",
  null
  
)

export default component.exports